/**
 * usePageTracking - sends a GA page view on every route change
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

const usePageTracking = () => {
  const location = useLocation();
  const lastPathRef = useRef(null); // Avoid duplicate hits from StrictMode double effects

  useEffect(() => {
    const path = location.pathname + location.search;
    if (lastPathRef.current === path) return;
    lastPathRef.current = path;
    trackPageView(path);
  }, [location.pathname, location.search]);
};

export default usePageTracking;
